import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe('pk_live_51TPVJMRsLumT6qbb337CFlgr6DttYBcSjRI3BRjZviUGPuhTETyfIzHSpchNyC1kZvhXJElaE6Gkgc9UqiBxYn6K00viVhYvws');

export const PRICES = {
  event: 'price_1TxYr0RsLumT6qbbyvVFkIsR',        // £3.99 one-off
  unlimited: 'price_1TxYtgRsLumT6qbbmmV3EmjZ',     // £24.99 / month
};